import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { PlayerService } from '../../services/player.service';

/**
 * Route component for direct-URL sign-out (`/logout`).
 * Performs the exact same clear + redirect as the header account-menu Logout action:
 * guarded social-provider sign-out, canonical local-session clear via
 * PlayerService.logout() (LocalStorageService.clearAll), then redirect to /login.
 */
@Component({
  selector: 's18-logout',
  template: `<div style="padding:40px; text-align:center">Signing out&hellip;</div>`
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: SocialAuthService,
    private playerService: PlayerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Social-provider sign-out can reject when there is no active social session;
    // guard it so it can never block the local session clear + redirect.
    try {
      this.authService.signOut();
    } catch {
      // no active social session - safe to ignore
    }
    this.playerService.logout();
    this.router.navigateByUrl('/login');
  }
}
